import {
  AppBar,
  Toolbar,
  Container,
  Box,
  IconButton,
  Button,
  styled,
} from '@mui/material';
import { useState } from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import ALogo from '../../assets/logos/light/assegurados-horizontal-light.svg';
import { Link, useNavigate } from 'react-router-dom';
import { DrawerMenu } from '../drawer-menu/drawer-menu.container';
import { LoginButton } from '../login-button/login-button.component';

const pages = [
  { title: 'Sobre nós', url: 'sobre-nos' },
  { title: 'Seguro Viagem', url: 'trip-ensurance' },
  { title: 'Dúvidas', url: 'duvidas' },
  { title: 'Blog', url: 'blog' },
];

const StyledLink = styled(Link)(({ theme }) => ({
  textDecoration: 'none',
  color: 'inherit',
  '&:hover': {
    textDecoration: 'none',
    '& .MuiTypography-root': {
      color: theme.palette.primary.main,
    },
  },
}));

const HeaderComponent = ({ user }) => {
  const navigate = useNavigate();

  const [menuOpen, setMenuOpen] = useState(false);

  const toggleDrawer = (newOpen) => () => {
    setMenuOpen(newOpen);
  };

  const handleOpenUserMenu = (newOpen) => {
    setMenuOpen(false);
    if (!user) {
      navigate('/authentication');
    } else {
      navigate('/my-orders');
    }
  };

  return (
    <AppBar position="static">
      <Container maxWidth="lg">
        <Toolbar disableGutters>
          <Link to="/">
            <Box
              component="img"
              src={ALogo}
              alt="Assegurados"
              sx={{ display: 'flex', mr: 1, width: { xs: '150px' } }}
            />
          </Link>
          <Box
            sx={{
              display: { xs: 'flex', md: 'none' },
              alignItems: 'center',
              justifyContent: 'flex-end',
              flexGrow: 1,
              ml: 'auto',
            }}
          >
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={toggleDrawer(true)}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <DrawerMenu
              toggleDrawer={toggleDrawer}
              open={menuOpen}
              user={user}
              pages={pages}
              handleOpenUserMenu={handleOpenUserMenu}
              navigate={navigate}
            />
          </Box>
          <Box
            sx={{
              flexGrow: 1,
              display: { xs: 'none', md: 'flex' },
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {pages.map((page, index) => (
              <Button
                key={`${page.title}-${index}`}
                sx={{ my: 2, color: 'white', display: 'block' }}
              >
                {page.url ? (
                  <StyledLink to={page.url}>{page.title}</StyledLink>
                ) : (
                  page.title
                )}
              </Button>
            ))}
          </Box>
          <Box sx={{ flexGrow: 0, display: { xs: 'none', md: 'block' } }}>
            <LoginButton
              user={user}
              handleOpenUserMenu={handleOpenUserMenu}
              navigate={navigate}
            />
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default HeaderComponent;
